import { useState } from "react";
import { useDebounceCallback, useEventListener, useWindowSize } from "usehooks-ts";
import { useOrientation } from "./orientation";

export const useScale = () => {
  const { landscape } = useOrientation();
  const { width, height } = useWindowSize();

  const getScale = () => {
    return landscape
      ? Math.max(470, Math.min(720, 187 + height * 0.6)) / 470
      : Math.min(Math.max(340, Math.min(604, width * 0.94 + 0.6)) / 278, height / 420);
  };

  const [scale, setScale] = useState(getScale());

  const handleResize = useDebounceCallback(() => {
    setScale(getScale());
  }, 250);

  useEventListener("resize", handleResize);

  return {
    scale,
  };
};
